module.exports = __webpack_public_path__ + "img/enchufe-emergencia.42119ccd.svg";